
import React, { useRef } from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Grid, InputLabel, Popper, Tooltip, Typography } from '@mui/material';
import { el } from 'react-date-range/src/locale/index';
import { IFormController } from '../types';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/system';
import InfoIcon from '@mui/icons-material/Info';
import Theme from '../../../Themes/main.theme';

function FormDatePicker(props: IFormController) {
  const { label, name, required, formik, customLabel, filtersDesign, info, ...rest } = props;
  const {t} = useTranslation();
  const [value, setValue] = React.useState(formik?.values[name]);

  const reference = useRef<HTMLDivElement>(null);
  const PopperMy = React.useCallback((props: any) => {
    return <Popper {...props}
      style={{ width: reference?.current?.clientWidth, position: 'absolute' }}
      placement='bottom-start'
    />;
  }, []);

  React.useEffect(() => {
    setValue(formik?.values[name]);
  }, [formik?.values[name]]);

  return (
    <Grid>
      {customLabel
        ? <Box display='flex' alignItems='center'> 
          <InputLabel
            htmlFor={name}
            sx={{
              textAlign: 'left',
              textStyle: 'none',
              my: 2
            }}
          >
            <Typography
              variant='body1'
              sx={{ fontWeight: '500' }}>
              {label}
            </Typography>
          </InputLabel>
          {info ? 
            <Tooltip
              PopperProps={{
                disablePortal: true
              }} title={props?.tooltip}
              placement='right-start'>
              <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '17px'}}/>
            </Tooltip>
            : null
          }
        </Box>
        : null}
      <LocalizationProvider
        locale={el} 
        dateAdapter={AdapterDateFns}>
        <DatePicker
          label={
            customLabel
              ? null
              : label
          }
          
          PopperProps={{
            disablePortal: true
          }}
  
          inputFormat='dd/MM/yyyy'
          value={value
            ? value
            : formik?.getFieldProps(`${name}`).value
              ? formik?.getFieldProps(`${name}`).value
              : null}
          onChange={(newValue: any) => {
            setValue(newValue);
            formik?.setFieldValue(`${name}`, newValue);
          }}
          renderInput={(params: any) => <TextField
            required={required}
            sx={{
              minWidth: 200,
              width: '100%',
              ...(filtersDesign && {
                '& .MuiOutlinedInput-root': {
                  '& > fieldset': {
                    borderRadius: '24px'
                  }
                }
              })
            }}
            {...params} 
            inputProps={{
              ...params.inputProps,
              placeholder: t('ΗΗ/ΜΜ/ΧΧΧΧ')
            }} 
          />}
          {...rest}
        />
      </LocalizationProvider>
    </Grid>
  );
}

export default FormDatePicker;